<template>
  <form class="sm-messages__main-messages-form">
    <div @click="$refs.file.click()">
      <include-svg :name="'icon-messages-attachments'" />
    </div>
    <input
      ref="file"
      hidden
      type="file"
      name="file"
      :accept="acceptTypes"
      @change="uploadFile($event, 'file')"
    />

    <div class="sm-messages__main-messages-form-middle">
      <textarea
        v-model="content"
        class="scrollable-y"
        placeholder="Write a message..."
      ></textarea>
      <span v-if="attachments">
        <p>{{ fileName }}<span @click.prevent="removeFile"><include-svg :name="'icon-action-close'"/></span></p>
      </span>
    </div>

    <button class="sm-btn" @click.prevent="submit">
      <include-svg :name="'icon-messages-submit'" />
    </button>
    <div v-if="disableForm" class="disable-overlay"></div>
  </form>
</template>

<script>
import { IsRightFileType } from "@/utils/general-data";
import MimeTypes from "@/settings/mime-types";
import IncludeSvg from '../IncludeSvg.vue';

export default {
  components: { IncludeSvg },
  name: "form-messages",
  props: {
    role: {
      type: String,
      required: true,
    },
    selectedRoom: {
      type: Object,
      required: true,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      content: "",
      attachments: "",
      types: ["pdf", "image"],
      acceptTypes: "",
      disableForm: false,
    };
  },
  created() {
    let typesArr = [];
    this.types.forEach(
      (type) => (typesArr = [...typesArr, MimeTypes[type].join()])
    );
    this.acceptTypes = typesArr.join();
  },
  methods: {
    isRightFileType: IsRightFileType,
    uploadFile(e) {
      if (e.target.files.length === 0) return false;

      const target = e.target;
      const file = target.files[0];

      if (!this.isRightFileType(file, this.types)) return false;

      this.attachments = file;
      this.fileName = file.name;
    },
    removeFile() {
      this.attachments = "";
      this.$refs.file.value = null;
    },
    updateEverything(createdRoom) {
      this.$emit("updateEverything", createdRoom);
    },
    sendMessage(messageParams, createdRoom) {
      this.setShowSpinner(true);

      this.$emit(
        "callMethod",
        "createNewMessage",
        (res) => {
          this.content = "";
          this.attachments = "";
          this.disableForm = false;
          this.updateEverything(createdRoom);
        },
        (err) => {
          console.log(err);
          this.disableForm = false;
          this.setShowSpinner(false);
        },
        messageParams
      );
    },
    createRoomThenSendMessage(params) {
      this.setShowSpinner(false);
      const messageParams = { ...params };
      const roomParams = {
        role: this.role,
        body: {
          account_id: this.selectedRoom.customer.id,
        },
      };
      this.$emit(
        "callMethod",
        "createNewRoom",
        (res) => {
          messageParams.room_id = res.messaging_room.id;
          return this.sendMessage(messageParams, res.messaging_room);
        },
        (err) => {
          console.log(err)
          this.setShowSpinner(false);
        },
        roomParams
      );
    },
   
    submit() {
      if (!this.content.trim() && this.attachments.length < 1) return;

      this.disableForm = true;
      const formData = new FormData();
      formData.append("message[content]", this.content.trim());
      if (this.attachments)
        formData.append("message[attachments][]", this.attachments);

      const params = {
        role: this.role,
        room_id: this.selectedRoom.id,
        message: formData,
      };

      if (this.selectedRoom.isFaked) {
        this.createRoomThenSendMessage(params);
      } else {
        this.sendMessage(params);
      }
    },
    setShowSpinner(val) {
      this.$emit('setShowSpinner', val)
    }
  },
};
</script>
